// extracted by mini-css-extract-plugin
var _1 = "CategoryTableRow-moduleCategoryTableRow__IA5Na TableComponent-modulerow__xPAo4";
export { _1 as "CategoryTableRow" }
